import './new-button.scss';

import { ComponentProps, HTMLAttributeAnchorTarget, ReactNode } from 'react';

import { ConvergeTooltip } from './converge-tooltip';
import { LoadingButton } from '@mui/lab';

interface IPrimaryButtonProps extends ComponentProps<typeof LoadingButton> {
  label: string;
  variant?: 'outlined' | 'contained' | 'text';
  loading?: boolean;
  tooltip?: ReactNode;
  target?: HTMLAttributeAnchorTarget;
  hasMargin?: boolean;
  dataTestId?: string;
}

export const NewConvergeButton = ({
  label,
  variant = 'contained',
  loading,
  disabled = loading,
  tooltip,
  href,
  hasMargin = false,
  target,
  dataTestId,
  ...other
}: IPrimaryButtonProps) => {
  const extraProps: Omit<IPrimaryButtonProps, 'label'> = {};

  if (href) {
    extraProps.href = href;
    extraProps.target = target;
  }

  const button = (
    <LoadingButton
      disabled={disabled}
      className={`${
        variant === 'contained' ? 'contained-design' : 'outlined-design'
      }`}
      loading={loading}
      {...extraProps}
      {...other}
      {...(dataTestId && { 'data-testid': dataTestId })}
    >
      {label}
    </LoadingButton>
  );

  return tooltip ? (
    <ConvergeTooltip title={tooltip}>
      <div>{button}</div>
    </ConvergeTooltip>
  ) : (
    button
  );
};
